// extracted by mini-css-extract-plugin
export default {"controlAreaContainer":"ControlArea_controlAreaContainer__jWzZ0","setupArea":"ControlArea_setupArea__e8uSm","eventLog":"ControlArea_eventLog__2IgoW"};